import { Box, List, ListItem, Typography } from '@coolblue-development/freddy';

export const ConditionDetail = ({ details }: { details: string[] }) => (
  <Box>
    <Typography color='subtle' component='h4' fontWeight='bold' m={0} fontSize='lg'>
      {details[0]}
    </Typography>
    <List ml={300} gap='compact'>
      {details.slice(1).map(detail => (
        <ListItem key={detail}>{detail.replace(/^- /, '')}</ListItem>
      ))}
    </List>
  </Box>
);
